import { render } from "./ServiceSummaryCard.vue?vue&type=template&id=364a8665&scoped=true"
import script from "./ServiceSummaryCard.vue?vue&type=script&lang=js"
export * from "./ServiceSummaryCard.vue?vue&type=script&lang=js"

import "./ServiceSummaryCard.vue?vue&type=style&index=0&id=364a8665&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364a8665"]])

export default __exports__